module.exports = function (lastField) {
    return {
        event: 'BWSAUcompetitionAbandoned',
        eventContext: {
            competitionLastField: lastField
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/atmmapper/competition-abandoned.js
 **/